import {CSSProperties, FC} from 'react';


export interface IIconPhoneNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPhoneNissan: FC<IIconPhoneNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.05 12.8c-.168 0-.343-.056-.511-.096a6.927 6.927 0 0 1-.998-.312c-.732-.28-1.547.065-1.89.8l-.167.36a9.336 9.336 0 0 1-2.027-1.6 9.72 9.72 0 0 1-1.524-2.128l.32-.224c.7-.36 1.028-1.215.762-1.984a8.591 8.591 0 0 1-.297-1.048 6.182 6.182 0 0 1-.091-.544c-.192-1.164-1.161-2.01-2.286-1.992H7.055a2.24 2.24 0 0 0-1.737.815A2.482 2.482 0 0 0 4.77 6.76c.835 6.895 6.017 12.316 12.586 13.168h.29c.562 0 1.104-.216 1.523-.608a2.455 2.455 0 0 0 .762-1.8v-2.4c-.019-1.146-.807-2.118-1.882-2.32Zm.38 4.8c0 .23-.094.448-.259.6a.774.774 0 0 1-.624.2c-5.87-.79-10.483-5.657-11.208-11.824a.902.902 0 0 1 .19-.656.747.747 0 0 1 .572-.272h2.286a.77.77 0 0 1 .762.632c.03.219.068.435.114.648.088.422.205.836.35 1.24l-1.066.52a.786.786 0 0 0-.398.45c-.07.2-.061.421.024.614 1.097 2.466 2.985 4.449 5.334 5.6.185.08.393.08.579 0a.777.777 0 0 0 .434-.416l.472-1.12c.394.148.796.27 1.204.368.203.048.41.088.617.12.358.08.61.416.602.8l.015 2.496Z" clipRule="evenodd" />
        </svg>
    );
};
